<template>
  <div>
    <div class="table-title">
      <div class="subject">
        <p>Users</p>
        <span v-if="dataAdded">
          Total ({{users.length}})
        </span>
      </div>
    </div>

    <div class="table-head" v-if="isDesktop()">
      <p>ID</p>
      <p class="d-xl">Email</p>
      <p class="d-xl">Name</p>
      <p>Verified</p>
      <p>2FA</p>
      <p>Status</p>
    </div>

    <div class="table-body">
      <div class="table-row cursor"
        v-for="(user, index) in users" :key="index"
        @click="showUserDetails(user.id)"
      >
        <p>
          <b v-if="!isDesktop()">ID:</b>
          {{user.id}}
        </p>
        <p class="d-xl mt-right break">
          <b v-if="!isDesktop()">Email:</b>
          {{user.email}}
        </p>
        <p class="d-xl">
          <b v-if="!isDesktop()">Name:</b>
          {{user.name || 'Hypto Admin'}}
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">Verified:</b>
          {{user.verified}}
        </p>
        <p>
          <b v-if="!isDesktop()">2FA:</b>
          {{user.tfa_enabled ? 'Enabled' : 'Disabled'}}
        </p>
        <p class="mt-grey-text mt-right">{{user.status}}</p>
      </div>
    </div>

    <table-loader v-if="!dataAdded" />

    <div class="table-empty" v-else-if="users.length === 0">
      <p>No Users assigned</p>
    </div>
  </div>
</template>

<script>
import TableLoader from '@/components/global/TableLoader'

export default {
  name: 'UsersList',
  components: { TableLoader },
  props: {
    users: Array,
    dataAdded: Boolean
  },
  methods: {
    showUserDetails (id) {
      this.$router.push({name: 'UserDetails', params: {id}})
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/table.scss';

  .break {
    word-break: break-all;
  }
</style>
